import { useRouter } from 'next/router';

import { useHeaderTitleText, useBackButton } from 'utils/localeHelper';
import { getStepNumber } from './ProgressBar';

const HeaderTitle: React.FC = () => {
  const router = useRouter();
  const titleText = useHeaderTitleText();
  const showBackButton = useBackButton();

  // Renewed thank-you page doesn't need HeaderTitle
  if (getStepNumber(router.pathname) === 20) {
    return null;
  }

  return (
    <>
      <h1 className="relative text-green-200 text-center font-bold leading-tight">
        {showBackButton && (
          <img
            className="absolute ltr:left-1 rtl:right-1 top-1/2 transform -translate-y-1/2 rtl:-scale-x-100 cursor-pointer z-10"
            width="10"
            height="10"
            src="/assets/o_series/chevron_back.svg"
            onClick={() => router.back()}
          />
        )}
        <span className="block relative pt-1 px-10 uppercase">{titleText}</span>
      </h1>
    </>
  );
};

export default HeaderTitle;
